import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function PreksGame(props) {
    return (
        <section  className="preksgame p50">
            <Container>
                <Row>
                    <Col xxl={5} xl={5} lg={5}>
                        <h2>Perks Of Working  With A Proficient Game App Development Company</h2>
                        <p>Collaborating with TekRevol streamlines your game idea and turns it into a living and breathing masterpiece. We carefully handle every aspect, ensuring a seamless journey and providing you with a top-tier experience.</p>
                    </Col>
                    <Col xxl={6} xl={6} lg={7} className="offset-xl-1">
                        <div className="preks_box">
                            <div className="preks_item">
                                <h6>Utilization of Modern Technologies <span>01</span></h6>
                                <p>Innovating your business by utilizing the latest technologies for game app development with robust features.</p>
                            </div>
                            <div className="preks_item">
                                <h6>Scalability and Flexibility Options <span>02</span></h6>
                                <p>Scale up your game application based on the increasing requirements with our flexible development approach.</p>
                            </div>
                            <div className="preks_item">
                                <h6>Absolute Process Transparency <span>03</span></h6>
                                <p>Stay consistently informed about the ongoing procedures by utilizing our project management tools, taking into account all relevant insights.</p>
                            </div>
                            <div className="preks_item">
                                <h6>Cost-Effective Pricing Models Options <span>04</span></h6>
                                <p>Get the right estimate for your project from our app cost calculator formulated with cost-effective pricing models.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default PreksGame;